export const PASSWORD_STRENGTH_BAR = {
    SHORT_PASSWORD_STRENGTH: {
        key: 'SHORT_PASSWORD_STRENGTH',
        value: 'short'
    },
    WEAK_PASSWORD_STRENGTH: {
        key: 'WEAK_PASSWORD_STRENGTH',
        value: 'weak'
    },
    FAIR_PASSWORD_STRENGTH: {
        key: 'OKAY_PASSWORD_STRENGTH',
        value: 'fair'
    },
    GOOD_PASSWORD_STRENGTH: {
        key: 'GOOD_PASSWORD_STRENGTH',
        value: 'good'
    },
    STRONG_PASSWORD_STRENGTH: {
        key: 'STRONG_PASSWORD_STRENGTH',
        value: 'strong'
    },  
    USER_PASSWORD_PLACEHOLDER: {
        key: 'USER_PASSWORD_PLACEHOLDER',
        value: 'Enter password'
    }
};